import { useAccessibility } from "../../context/AccessibilityContext/AccessibilityContext";
import Modal from "../Modal/Modal";
import { useState } from 'react';
import style from './achievementmodal.module.scss';

const AchievementModal = ({ achievement, onClose }) => {
    const { settings: { contrast } } = useAccessibility();
    const [imageLoaded, setImageLoaded] = useState(false);

    if (!achievement) return null;

    const backgroundColor = contrast === 'default' ? '#fff' : 'var(--bg-primary)';
    const textColor = contrast === 'default' ? '#231f20' : 'var(--text-primary)';
    const accentColor = contrast === 'default' ? '#1d3e8c' : 'var(--accent-color)';
    const borderColor = contrast === 'default' ? '#e5e5e5' : 'var(--border-color)';

    const getTextContent = () => {
        const content = achievement.description;
        if (!content) {
            return [<p key="no-content" className={style.achievementParagraph}>Описание достижения недоступно</p>];
        }
        if (typeof content === 'string') {
            const paragraphs = content.split('\n').filter(para => para.trim());
            if (paragraphs.length === 0) {
                return [<p key="no-content" className={style.achievementParagraph}>Описание достижения недоступно</p>];
            }
            return paragraphs.map((paragraph, index) => (
                <p key={index} className={style.achievementParagraph}>{paragraph}</p>
            ));
        }
        return [<p key="no-content" className={style.achievementParagraph}>Описание достижения недоступно</p>];
    };

    return (
        <Modal active={!!achievement} setActive={onClose} width="90%" maxWidth="900px" height="auto" maxHeight="90vh" padding="0">
            <div className={style.achievementModalContent} style={{ background: backgroundColor, color: textColor }}>
                <button className={style.closeButton} onClick={onClose} aria-label="Закрыть" style={{ color: textColor, border: `2px solid ${borderColor}`, background: backgroundColor }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>
                
                <div className={style.scrollableContainer}>
                    {achievement.image && (
                        <div className={style.achievementHeader}>
                            <div className={style.imageContainer}>
                                <img src={achievement.image} alt={achievement.title} className={style.achievementImage} onLoad={() => setImageLoaded(true)} onError={(e) => e.target.style.display = 'none'} />
                                {!imageLoaded && <div className={style.imageLoader}><div className={style.loaderSpinner}></div></div>}
                            </div>
                        </div>
                    )}
                    
                    <div className={style.achievementBody}>
                        <div className={style.achievementMeta}>
                            {achievement.year && <span className={style.achievementYear}>{achievement.year}</span>}
                        </div>
                        
                        {achievement.competition && (
                            <div className={style.competitionInfo}>
                                <span className={style.competitionLabel}>Соревнование:</span>
                                <span className={style.competitionName}>{achievement.competition}</span>
                            </div>
                        )}
                        
                        <h1 className={style.achievementTitle}>{achievement.title}</h1>
                        
                        <div className={style.achievementText}>{getTextContent()}</div>
                        
                        <div className={style.achievementFooter}>
                            <button className={style.closeActionButton} onClick={onClose} style={{ background: accentColor, color: '#fff' }}>Закрыть</button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AchievementModal;